import { useRef, useState } from "react"
import { Box, Stack } from "@mui/material"
import { useAuth0 } from "@auth0/auth0-react"
import { uploadLogo } from '../../../../../../utilities/apiRequests.js'
import { getLogoUrl } from "../../../../../../utilities/consts.js"


export function PencilButton({...params}){

    let pageMode = params.pageMode
    let channelID = params.channelID
    let setLogoURLState = params.setLogoURLState

    let [pencilButtonState, setPencilButtonState] = useState('default')
    const fileInputRef = useRef(null);

    const { getAccessTokenSilently } = useAuth0();

    let pencilPaths = {
        default: "/icons/icons-shared/icon-pencil-default.svg",
        hover: "/icons/icons-shared/icon-pencil-hover.svg",
        inactive: "/icons/icons-shared/icon-pencil-inactive.svg",
    }

    const handleButtonHover = (event) => {
        event.preventDefault()
        setPencilButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setPencilButtonState('default')
    }


    let imagePath = ''
    if (pageMode === 'read') imagePath = pencilPaths.inactive
    else if (pageMode === 'edit'){
        if (pencilButtonState === 'hover') imagePath = pencilPaths.hover
        else imagePath = pencilPaths.default
    }


    function handlePencilClick(){
        fileInputRef.current.click();
    }

    async function handleLogoUpload(event){
        const file = event.target.files[0];
        const accessToken = await getAccessTokenSilently({ authorizationParams: { scope: "write:channels" } });
        const fileObject = new File([file], `${channelID}.svg`, {type: file.type});
        await uploadLogo(accessToken, channelID, fileObject)
        setTimeout(() => 
            setLogoURLState({
                imageSrc: `${getLogoUrl()}/${channelID}.svg`,
                imageHash: Date.now()
            }), 3000
        )
    } 

    return (
        <Stack direction={'column'} justifyContent={'center'} zIndex={9}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onMouseDown={() => handlePencilClick()}>

            <input
                type="file"
                style={{ display: 'none' }}
                ref={fileInputRef}
                onChange={(event) => handleLogoUpload(event)}
            />

            <Box component="img" src={imagePath} width={'20px'} height={'20px'} className={"PencilButton"}/>
        </Stack>
    )
}
